import { render } from "./musrufypay.vue?vue&type=template&id=b58d6472&scoped=true"
import script from "./musrufypay.vue?vue&type=script&lang=js"
export * from "./musrufypay.vue?vue&type=script&lang=js"

import "./musrufypay.vue?vue&type=style&index=0&id=b58d6472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58d6472"]])

export default __exports__